<template>
  <div>
    <b-form-checkbox v-model="enableCopy" name="check-button" switch></b-form-checkbox>
  </div>
</template>

<script>
export default {
  props: {
    clinician: {
      type: Object,
    },
  },
  data() {
    return {
      enableCopy: this.clinician.parents,
    };
  },
  watch: {
    enableCopy(newValue) {
      this.$emit('updateClinicianReport', { ...this.clinician, parents: newValue });
    },
    clinician(newValue) {
      this.enableCopy = newValue.parents;
    },
  },
};
</script>
